import { theme } from '@bigcommerce/big-design-theme'

export enum StoreStatusEnum {
  Pending = '0',
  Active = '1',
  Suspend = '2',
  Cancelled = '3',
  Terminated = '4',
}

export const STORE_STATUS_MAP: { [K in string]: string } = {
  1: 'Pending',
  2: 'Provisioning',
  3: 'Allocating',
  4: 'Active',
  5: 'Suspending',
  6: 'Suspended',
  7: 'Canceling',
  8: 'Cancelled',
  9: 'Terminated',
  10: 'Error',
}

export const STORE_STATUS_COLOR_MAP: { [K in string]: string } = {
  1: '#0B38D9',
  2: 'rgba(83, 29, 171, 0.88)',
  3: '#995D2F',
  4: '#2AAB3F',
  5: '#FFBF00',
  6: '#CC720A',
  7: '#AD0000',
  8: 'rgba(49, 52, 64, 0.88)',
  9: 'rgba(49, 52, 64, 0.88)',
  10: '#AD0000',
}

export const StoresStatusOptions = Object.keys(STORE_STATUS_MAP).map(
  (s: string) => ({
    value: s,
    content: STORE_STATUS_MAP[s],
  }),
)

enum PlanCodeEnum {
  Sandbox = 'Sandbox Store',
  Plus = 'Plus',
  Standard = 'Standard',
  Pro = 'Pro',
  Trial15 = 'Trial-15',
}

export const PlanCodeItemColorMap = (key: string): string => {
  const colorMap: { [key: string]: string } = {
    [PlanCodeEnum.Sandbox]: theme.colors.success,
    [PlanCodeEnum.Plus]: '#531DAB',
    [PlanCodeEnum.Standard]: theme.colors.primary,
    [PlanCodeEnum.Pro]: theme.colors.warning,
    [PlanCodeEnum.Trial15]: theme.colors.success,
  }

  return Object.values(PlanCodeEnum).includes(key as PlanCodeEnum)
    ? colorMap[key]
    : '#f2ba0a'
}

export const StoreLogTypeOptions = [
  {
    value: 'general',
    content: 'General Message',
  },
  {
    value: 'payment',
    content: 'Payment Gateway',
  },
  {
    value: 'shipping',
    content: 'Shipping Quote',
  },
  {
    value: 'tax',
    content: 'Tax Quotes',
  },
  {
    value: 'promotion',
    content: 'Promotion',
  },
  {
    value: 'notification',
    content: 'Notification System',
  },
  {
    value: 'emailintegration',
    content: 'Email Integration',
  },
  {
    value: 'ebay',
    content: 'eBay',
  },
  {
    value: 'shoppingcompanison',
    content: 'Shopping Comparison',
  },
  {
    value: 'ordersettings',
    content: 'Order Settings',
  },
  {
    value: 'square',
    content: 'Square',
  },
  {
    value: 'facebook',
    content: 'Facebook',
  },
  {
    value: 'pinterest',
    content: 'Pinterest',
  },
  {
    value: 'design',
    content: 'Design',
  },
  {
    value: 'inventory',
    content: 'Inventory',
  },
]

export const SeverityOptions = [
  {
    value: '1',
    content: 'Success',
  },
  {
    value: '2',
    content: 'Notice',
  },
  {
    value: '3',
    content: 'Warning',
  },
  {
    value: '4',
    content: 'Error',
  },
]
